import { render, staticRenderFns } from "./PostaCellChannelDetail.vue?vue&type=template&id=fdbd1258&scoped=true"
import script from "./PostaCellChannelDetail.vue?vue&type=script&lang=js"
export * from "./PostaCellChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./PostaCellChannelDetail.vue?vue&type=style&index=0&id=fdbd1258&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbd1258",
  null
  
)

export default component.exports